// extracted by mini-css-extract-plugin
module.exports = {"table":"reportWalletDetail_table__muAOB","hidden":"reportWalletDetail_hidden__1p7kw"};